import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { BranchProvider } from "@/contexts/BranchContext";
import { TabsProvider } from "@/contexts/TabsContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { IdleTimeoutWarning } from "@/components/IdleTimeoutWarning";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import VoucherVerifyPage from "@/pages/VoucherVerifyPage";

// Single catch-all route: Layout owns the multi-tab work area; TabsProvider sources
// the active tab from the URL and renders every open tab simultaneously (preserves
// form state on tab switch).
function App() {
  return (
    <AuthProvider>
      <BranchProvider>
        <IdleTimeoutWarning />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* Public read-only voucher verification (QR on movement PDFs) */}
            <Route path="/verify/:vtype/:vid/:sig" element={<VoucherVerifyPage />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <TabsProvider>
                    <Layout />
                  </TabsProvider>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </BranchProvider>
    </AuthProvider>
  );
}

export default App;
